/**
 * 封装 localStorage
 */
export default {
  /**
   *
   * @param {*} key
   * @param {*} value
   */
  set (key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
  },
  /**
   *
   * @param {*} key
   */
  get (key) {
    let value = window.localStorage.getItem(key)
    try {
      value = JSON.parse(value)
    } catch (error) {}

    return value
  },
  /**
   *
   * @param {*} key
   */
  remove (key) {
    window.localStorage.removeItem(key)
  },
  /**
   *
   */
  clear () {
    window.localStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/helpers/storage.js